import { Contact, isContact } from '../../api/contacts';

export interface AuthenticatedContact extends Contact {
    additional_data: AuthenticatedContactAditionalData;
}

export interface AuthenticatedContactAditionalData {
    role: AuthenticatedContactRoles;
}

export enum AuthenticatedContactRoles {
    // Generic roles
    ADMIN = 'admin',
    USER = 'user',
    LAUNDRY = 'laundry',
    EMPLOYEE = 'employee',
    INTERIM = 'interim',
    MANAGER = 'manager',

    NOODDORP_DELIVERY = 'nooddorp_delivery',
    DELIVERY_NS = 'deliveryNS',
    // STANDARD_DELIVERY and DELIVERY are treated the same
    STANDARD_DELIVERY = 'standard_delivery',
    DELIVERY = 'delivery',
    EMPLOYEE_NS = 'employeeNS',
    NS = 'ns',
    OPEN_DROPOFF_ALLOWED = 'open_dropoff_allowed',
}

export function isAdmin(contact: Contact | undefined) {
    return isGlobalContact(contact) && contact.additional_data.role === AuthenticatedContactRoles.ADMIN;
}

export function isDelivery(contact: Contact | undefined) {
    return (
        isGlobalContact(contact) &&
        (contact.additional_data.role === AuthenticatedContactRoles.DELIVERY_NS ||
            contact.additional_data.role === AuthenticatedContactRoles.DELIVERY ||
            contact.additional_data.role === AuthenticatedContactRoles.NOODDORP_DELIVERY ||
            contact.additional_data.role === AuthenticatedContactRoles.STANDARD_DELIVERY)
    );
}

export function isNoodorpDelivery(contact: Contact | undefined) {
    return isGlobalContact(contact) && contact.additional_data.role === AuthenticatedContactRoles.NOODDORP_DELIVERY;
}

export function isOpenDropoffAllowed(contact: Contact | undefined) {
    return isGlobalContact(contact) && contact.additional_data.role === AuthenticatedContactRoles.OPEN_DROPOFF_ALLOWED;
}

export function isNSDelivery(contact: Contact | undefined) {
    return isGlobalContact(contact) && contact.additional_data.role === AuthenticatedContactRoles.DELIVERY_NS;
}

export function isNSEmployee(contact: Contact | undefined) {
    return isGlobalContact(contact) && contact.additional_data.role === AuthenticatedContactRoles.EMPLOYEE_NS;
}

export function isEmployee(contact: Contact | undefined) {
    return isGlobalContact(contact) && contact.additional_data.role === AuthenticatedContactRoles.EMPLOYEE;
}

export function isInterim(contact: Contact | undefined) {
    return isGlobalContact(contact) && contact.additional_data.role === AuthenticatedContactRoles.INTERIM;
}

export function isUser(contact: Contact | undefined) {
    return isGlobalContact(contact) && contact.additional_data.role === AuthenticatedContactRoles.USER;
}

export function isManager(contact: Contact | undefined) {
    return isGlobalContact(contact) && contact.additional_data.role === AuthenticatedContactRoles.MANAGER;
}

export function isLaundry(contact: Contact | undefined) {
    return isGlobalContact(contact) && contact.additional_data.role === AuthenticatedContactRoles.LAUNDRY;
}

export function isGlobalContact(contact: Contact | null | undefined): contact is AuthenticatedContact {
    return contact !== null && contact !== undefined && isContact(contact) && isGlobalContactAditionalData(contact.additional_data);
}

function isGlobalContactAditionalData(additional_data: unknown): additional_data is AuthenticatedContactAditionalData {
    return (
        additional_data !== undefined &&
        additional_data !== null &&
        (additional_data as AuthenticatedContactAditionalData).role !== undefined &&
        (additional_data as AuthenticatedContactAditionalData).role !== null &&
        isGlobalContactRole((additional_data as AuthenticatedContactAditionalData).role)
    );
}

function isGlobalContactRole(role: unknown): role is AuthenticatedContactRoles {
    return (
        role !== undefined && role !== null && typeof role == 'string' && Object.values(AuthenticatedContactRoles).includes(role as AuthenticatedContactRoles)
    );
}
